import React from 'react';
import { HStack, VStack } from '@chakra-ui/react';
import ComposerDueDateField from './ComposerDueDateField.tsx';
import ComposerFrequencyReveal from './ComposerFrequencyReveal.tsx';
import ComposerRepeatToggle from './ComposerRepeatToggle.tsx';
import { TaskScheduleController } from './useTaskComposer.ts';
import type { getSlideInCss } from '@/components/ui/motion.ts';

interface ComposerTaskScheduleControlsProps {
	task: TaskScheduleController;
	title?: string;
	controlsCss?: ReturnType<typeof getSlideInCss>;
	onToggleRecurring?: () => void;
}

const ComposerTaskScheduleControls: React.FC<ComposerTaskScheduleControlsProps> = (props) => {
	const { task, title = '', controlsCss, onToggleRecurring } = props;
	const shouldHighlightDueDate = title.trim().length > 0 && !task.startDate;

	return (
		<VStack flex={1} minW={0} align="stretch" gap={0}>
			<HStack flex={1} minW={0} gap={2} css={controlsCss}>
				<ComposerDueDateField
					startDate={task.startDate}
					onStartDateChange={task.setStartDate}
					disabled={task.isSubmitting}
					highlightPlaceholder={shouldHighlightDueDate}
				/>
				<ComposerRepeatToggle
					isRecurring={task.isRecurring}
					onToggle={onToggleRecurring ?? task.toggleRecurring}
					disabled={task.isSubmitting}
				/>
			</HStack>

			<ComposerFrequencyReveal task={task} />
		</VStack>
	);
};

export default ComposerTaskScheduleControls;
